module.exports = [{
      plugin: require('../node_modules/@whitespace/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"mtmContainerId":"container_X3XDs5Gr","includeInDevelopment":false,"mtmHost":"https://premium.analys.cloud","routeChangeEventName":false,"trackPageViews":true,"mtmDefaultDataVariable":null,"mtmPAQDefaultDataVariable":null,"requireCookieConsent":false},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
